/* eslint-disable no-multi-str */
import { debounce } from 'lodash'
import React, { useCallback, useMemo, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { toast } from 'react-toastify'
import {
  FormDashboardInput as Input,
  FormDashboardLabel as Label,
  FormRow,
  Loader,
  Table,
  // LinkAdder,
} from '../../../components'
import { fetchAccount } from '../../../features/account/slice'
import apiService from '../../../features/api/service'
import { useInternationalization } from '../../../features/i18n'
import { fetchIndividu } from '../../../features/individu/slice'
import { errorHandler } from '../../../utils'

const FormSocial = ({form, /* setForm, */ updateForm}) => {
  const dispatch = useDispatch()
  const [requesting, setRequesting] = useState(false)
  const linkTypes = useSelector(state => state.system.linkTypes)
  const { sosialMedia: socialLinks } = useSelector(state => state.individu.data)
  const myId = useSelector(state => state.account.profile.id)
  const { translate, language } = useInternationalization()

  const handleInput = debounce((e) => {
    updateForm(e)
  }, 100)

  const handleDelete = useCallback((id) => {
    console.log({id})
    if(requesting === false){
      apiService.delete('individu_social_media', id)
        .then(() => {
          toast.success('Deleted.')
          dispatch(fetchAccount())
          dispatch(fetchIndividu(myId))
        })
        .catch(err => {
          const msg = errorHandler(err)
          toast.error(msg)
        })
        .finally(() => setRequesting(false))
    }
  }, [requesting, dispatch, myId])

  const tableColumns = useMemo(
    () => [
      {
        Header: translate('GENERAL', 'name'),
        accessor: 'kategoriSosialMedia',
        Cell: (props) => {
          return props.value.nama[0]
        },
      },
      {
        Header: 'Link',
        accessor: 'linkSosialMedia',
      },
      {
        Header: '',
        accessor: 'pkSosialMediaId',
        Cell: (props) => (
          <div>
            <button type="button" className="text-sm underline text-gray-444" onClick={() => handleDelete(props.value)}>
              {translate('GENERAL', 'delete')}
            </button>
          </div>
        )
      }
    ],
    [handleDelete, translate]
  )

  return (
    <React.Fragment>
      <p className="text-lg font-bold mb-5 lg:mb-8">
        {translate('GENERAL', 'social_media')} ({translate('GENERAL', 'optional')})
      </p>
      {
        requesting &&
        <div className="py-8 flex items-center justify-center">
          <Loader />
        </div>
      }
      {
        (socialLinks && socialLinks.length > 0) &&
        <div className="mb-8">
          <div className="mobile-fullwidth overflow-x-auto">
            <Table
              columns={tableColumns}
              data={socialLinks}
            />
          </div>
        </div>
      }
      {
        linkTypes.map((d, i) => (
          <FormRow key={i}>
            <Label>{d.name[language.name]}</Label>
            <Input
              className="w-full"
              // defaultValue={form[`link_${d.id}`]}
              name={`link_${d.id}`}
              onChange={e => {e.persist(); handleInput(e)}}
            />
          </FormRow>
        ))
      }
      {/* <FormRow>
        <LinkAdder
          prefix="https://facebook.com/"
          label="Facebook"
          defaultState={true}
          defaultValue="peacegen_id"
          name="link_facebook"
          onChange={updateForm}
          onRemove={() => setForm({...form, link_facebook: undefined})}
        />
      </FormRow>
      <FormRow>
        <LinkAdder
          prefix="https://instagram.com/"
          label="Instagram"
          defaultState={true}
          defaultValue="peacegen_id"
          name="link_instagram"
          onChange={updateForm}
          onRemove={() => setForm({...form, link_instagram: undefined})}
        />
      </FormRow>
      <FormRow>
        <LinkAdder
          prefix="https://youtube.com/"
          label="Youtube"
          defaultState={true}
          name="link_youtube"
          onChange={updateForm}
          onRemove={() => setForm({...form, link_youtube: undefined})}
        />
      </FormRow>

      <hr className="hidden lg:block my-8 lg:my-10"/>

      <div className="mb-8 lg:mb-16">
        <LinkAdder
          className="mb-5"
          prefix="https://twitter.com/"
          label="Twitter"
          name="link_twitter"
          onChange={updateForm}
          onRemove={() => setForm({...form, link_twitter: undefined})}
        />
        <LinkAdder
          className="mb-5"
          prefix="https://linkedin.com/"
          label="LinkedIn"
          name="link_linkedin"
          onChange={updateForm}
          onRemove={() => setForm({...form, link_linkedin: undefined})}
        />
        <LinkAdder
          className="mb-5"
          prefix="https://medium.com/"
          label="Medium"
          name="link_medium"
          onChange={updateForm}
          onRemove={() => setForm({...form, link_medium: undefined})}
        />
        <LinkAdder
          className="mb-5"
          prefix="https://pinterest.com/"
          label="Pinterest"
          name="link_pinterest"
          onChange={updateForm}
          onRemove={() => setForm({...form, link_pinterest: undefined})}
        />
        <LinkAdder
          className="mb-5"
          label="Other Link"
          name="link_other"
          onChange={updateForm}
          onRemove={() => setForm({...form, link_other: undefined})}
        />
      </div> */}
    </React.Fragment>
  )
}

export { FormSocial }
